import {Component} from "react";

export class SellToWebTableColumnInputComponent extends Component {
}